module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isRoomsType) ? _c('RoomsBlock', {
    attrs: {
      "student_url": _vm.student_url,
      "record_url": _vm.record_url,
      "date": _vm.date,
      "isDateAfterToday": _vm.isDateAfterToday,
      "webinar_started": _vm.webinar_started,
      "link_state": _vm.link_state
    }
  }) : (_vm.isLessonsType) ? _c('LessonsBlock', {
    attrs: {
      "date": _vm.date,
      "isLinks": _vm.isLinksOrFiles,
      "isOpenBlock": _vm.isOpenBlock
    },
    on: {
      "close": function($event) {
        return _vm.$emit("close")
      },
      "lookItems": _vm.lookItems
    }
  }) : (_vm.isTestsType) ? _c('TestsBlock', {
    attrs: {
      "date": _vm.date,
      "item": _vm.item,
      "isLinks": _vm.isLinksOrFiles,
      "isResult": _vm.isResult,
      "isOpenBlock": _vm.isOpenBlock
    },
    on: {
      "close": function($event) {
        return _vm.$emit("close")
      },
      "lookItems": _vm.lookItems
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-319bc561","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/info/components/block/components/legend/Legend.vue
// module id = 3988dfc7436d5e0d3ca7
// module chunks = 89